$(document).ready(function() {
  var $mediaSwiper = $('.media-swiper');
  var $graphSwiper = $('.graph-swiper');

  if ( $mediaSwiper.length ) {  
    var mediaSwiper = new Swiper('#MediaSwiper', {
      preloadImages: false,
      lazy: {
        loadPrevNext: false,
        loadPrevNextAmount: 2,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".media-swiper .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      loop: false,
      on: {
        beforeInit: function (swiper) {

        },
        afterInit: function (swiper) {

        },
        slideChange: function(swiper) {
          
        },
        resize: function(swiper) {
          swiper.update();
        }
      }
    });

    if ( $graphSwiper.length ) {
      var graphSwiper = new Swiper('.graph-swiper', {
        preloadImages: false,
        lazy: {
          loadPrevNext: false,
          loadPrevNextAmount: 2,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".graph-swiper .swiper-pagination",
          clickable: true,
        },
        loop: false,
        on: {
          beforeInit: function (swiper) {
  
          },
          afterInit: function (swiper) {
  
          },
          slideChange: function(swiper) {
            
          },
          resize: function(swiper) {
            swiper.update();
          }
        }
      });
    };

    if ( $('.tab-content-swiper').find('.swiper-slide').length > 2 ) {
      var tabNavSwiper = new Swiper('.tab-content-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        freeMode: true,
      });
    }
  }

  if ( $('.collapsible-ui').length > 0 ) {
    var $collapsibleUi = $('.collapsible-ui');

    if ( $collapsibleUi.length > 0 ) {
      getcollapsibleUIScrollHeight($collapsibleUi);
      
      var $collapsibleTitle = $collapsibleUi.find('.collapsible-ui__title');
      var item = '.collapsible-ui__item';
      var content = '.collapsible-ui__content';
    
      $collapsibleTitle.on('click', function(){        
        $this = $(this);
        $thisParent = $this.parent(item);
        $thisSiblings = $thisParent.parent('.collapsible-ui').find(item);
        $thisContent = $this.next(content);
        contentHeight = $thisContent.attr('data-scroll-height')*1 + 30;        
        
        if ( $thisParent.hasClass('active')) {
          $thisParent.removeClass('active');
        } else {
          $thisSiblings.each(function() {
            $(this).removeClass('active');
          });

          $thisParent.addClass('active');
        }
      });
    }

    function getcollapsibleUIScrollHeight(container) {
      var $collapsibleUi = container;
      var $item = $collapsibleUi.find('.collapsible-ui__item');
      $item.each(function() {
        var $this = $(this);
        var $thisContent = $this.find('.collapsible-ui__content');
        var contentScrollHeight = $thisContent.prop('scrollHeight');
        $thisContent.attr('data-scroll-height', contentScrollHeight + 20);
      });
    }
  }

  if ( $('[data-ui-component="tab-content-ui"]').length > 0) {
    var $components = $('[data-ui-component="tab-content-ui"]');

    $components.each(function(){
      var $this = $(this);
      var $tabMenu = $this.find('.tab-content-menu');
      var $tabMenuItem = $this.find('.tab-content-menu-item');
      var $tabMenuElem = $tabMenuItem.find('> a');
      var $tabContentContainer = $this.find('.tab-content-container');
      var $tabContent = $this.find('.tab-content');

      $tabMenuElem.on('click', function(event) {
        var $activeMenuElem = $(this);
        var $activeMenuItem = $activeMenuElem.parent('.tab-content-menu-item');
        var activeItemNo = $activeMenuItem.index() + 1;
        var $activeContent = $tabContentContainer.find('.tab-content:nth-child('+activeItemNo+')');

        event.preventDefault();

        if ( $activeMenuItem.hasClass('active')) {
          $tabMenuItem.each(function(){
            $(this).removeClass('active');
          });
          
          $tabContent.each(function(){
            $(this).removeClass('active');
          });
        } else {
          $tabMenuItem.each(function(){
            $(this).removeClass('active');
          });
          
          $tabContent.each(function(){
            $(this).removeClass('active');
          });
  
          $activeMenuItem.toggleClass('active');
          $activeContent.toggleClass('active');
        }     
      });
    });
  }

  function playVideoWhenVisible(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }
  
  let observer = new IntersectionObserver(playVideoWhenVisible, {
    root: null,
    threshold: 0.5
  });
  
  let videoElementInSection = document.querySelector('.product-information-section video');

  if (videoElementInSection) {
    observer.observe(videoElementInSection);
  }
});